import { ADDRESS_HIDDEN_REGEXP } from '../../constants/address'

export const checkAddressHidden = (
  address: string | null | undefined
): address is '' | null | undefined | `${string}address ${'hidden' | 'not disclosed'}${string}` =>
  !address ? true : ADDRESS_HIDDEN_REGEXP.test(address)

export const joinAddress = <
  Separator extends string,
  Word extends string | number | null | undefined,
>(
  separator: Separator,
  ...words: readonly Word[]
) => words.filter(Boolean).join(separator)
